import isArray from "lodash-es/isArray";
import { stringify } from "qs";

export function stringifyQs(params: object): string {
  // 原代码
  // return stringify(params, {
  //   indices: false
  // });
  if (params) {
    // eslint-disable-next-line dot-notation
    if (params["ids"]) {
      // eslint-disable-next-line dot-notation
      if (params["ids"].length <= 1) {
        return stringify(params);
      } else {
        return stringify(params, {
          indices: false
        });
      }
    } else {
      return stringify(params);
    }
  } else {
    return stringify(params);
  }
}

export function getArrayQueryParam(param: string | string[]): string[] {
  if (!param) {
    return undefined;
  }

  if (isArray(param)) {
    return param;
  }

  return [param];
}
